function stylesheet(useActualHostSelector, token) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  return [".selected", shadowSelector, " {border: 2px solid #00ffff;}.notselected", shadowSelector, " {border: 1px solid blue;}.currently-selected", shadowSelector, " {border: 4px solid #66cccc !important;}.notselected", shadowSelector, " {border: 1px solid blue;padding: 3px;}"].join('');
}
export default [stylesheet];